import React, { PropTypes } from 'react';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { Button } from 'react-bootstrap';
import axios from '../../../../constants/axios.js';
import alert from 'alertify.js';
import selectOptionFormatter from './../../../../selectors/selectOptionFormatter';

import FormRenderField from './../../../FormTemplate/InputControl';
import Select from './../../../FormTemplate/Select';

class PartialPaymentForm extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         paymentAccounts: []
      };
   }

   componentDidMount() {
      axios.get('fixedAssets/getPaymentAccounts')
         .then((res) => {
            this.setState({
               paymentAccounts: selectOptionFormatter(res.data)
            });
         });
   }

   submit = (inputs) => {
      inputs.invoice_id = this.props.params.invoiceId;
      return axios.post('fixedAssets/partialPayment', inputs)
         .then((res) => {
            if (res.status === 201) {
               alert.success('Saved');
               this.context.router.push('/fixedAsset');
            } else {
               alert.error('Something Unexpected');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw  new SubmissionError(err.response.data);
            } else {
               alert.error('Ohh God. Sob Ses.');
            }
         });
   };

   render() {
      const { handleSubmit, submitting, invalid, error } = this.props;
      const { paymentAccounts } = this.state;
      return (
         <div>
            <h4>Partial Payment</h4>
            <form noValidate autoComplete="off" onSubmit={handleSubmit(this.submit)} >
               <Field name="amount" type="number" component={FormRenderField} label="Amount To Pay" />
               <Field name="payment_chart_of_account_id" allowEmpty={true} options={paymentAccounts}
                      component={Select} label="From Account" />
               {error && <strong className="input-validation-error" >{error}</strong>}
               <Button type="submit" bsStyle="success" block
                       disabled={submitting || invalid} >Pay</Button>
            </form>
         </div>
      );
   }
}

PartialPaymentForm.propTypes = {
   handleSubmit: PropTypes.func,
   submitting: PropTypes.bool,
   pristine: PropTypes.bool,
   invalid: PropTypes.bool,
   error: PropTypes.object,
   params: PropTypes.object,
   partialPaymentSubmit: PropTypes.func
};

PartialPaymentForm.contextTypes = {
   router: PropTypes.object
};

export default reduxForm({
   form: 'partialPayment',
   initialValues: {
      payment_chart_of_account_id: 1300,
   }
})(PartialPaymentForm);












/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/FixedAsset/FixedAssetPayment/PartialPaymentForm.js
 **/